import React from 'react'

export const LogsPage = () => {
    return (
        <>
            <iframe src={window.location.origin + '/Logs'} height="100%" width="100%" title='System Log' style={{ border: 0 }} />
        </>
    )
}
